export interface GeoFeature {
  type?: string;
  geometry: {
    type: string;
    coordinates: any;
  };
  properties: {
    [key: string]: any;
  };
}

export interface GeoJSON {
  type: string;
  features: GeoFeature[];
}

export const geoCenters: Record<string, { center: [number, number]; zoom: number }> = {
  'Australia Cities': { center: [135.7751, -26.2744], zoom: 1.1 },
  'Argentina Cities': { center: [-63.967, -38.604], zoom: 1.1 },
  'Brazil Cities': { center: [-51.567, -13.804], zoom: 1.1 },
  'Austria Cities': { center: [13.333, 47.683], zoom: 1.1 },
  'Belgium Cities': { center: [4.4499, 50.5], zoom: 1.1 },
  'Germany Cities': { center: [10.4515, 51.1657], zoom: 1.1 },
  'China Cities': { center: [104.1954, 35.8617], zoom: 1.1 },
  'France Cities': { center: [2.2137, 46.2276], zoom: 1.1 },
  'Ireland Cities': { center: [-8.2439, 53.4129], zoom: 1.1 },
  'Israel Cities': { center: [35.0916, 31.4461], zoom: 1.1 },
  'Italy Cities': { center: [12.5674, 41.2719], zoom: 1.1 },
  'Indian Cities': { center: [82.9629, 22.5937], zoom: 1.1 },
  'Philippines Cities': { center: [121.8, 13], zoom: 1.1 },
  'Japan Cities': { center: [138.8, 34.9], zoom: 1.1 },
  'Mexico Cities': { center: [-102.5528, 23.6345], zoom: 1.1 },
  'Malaysia Cities': { center: [109.4758, 4.1105], zoom: 1.1 },
  'Russia Cities': { center: [100.0188, 61.524], zoom: 1.1 },
  'Nigeria Cities': { center: [8.6753, 9.082], zoom: 1.1 },
  'Norway Cities': { center: [18, 64.3], zoom: 1.1 },
  'Poland Cities': { center: [19.1451, 51.9194], zoom: 1.1 },
  'Saudi Arabia Cities': { center: [45.0792, 24.3859], zoom: 1.1 },
  'South Africa Cities': { center: [27.3, -34.5], zoom: 1.1 },
  'South Korea Cities': { center: [127.7669, 35.9078], zoom: 1.1 },
  'Singapore Cities': { center: [103.8198, 1.359], zoom: 1.1 },
  'Spain Cities': { center: [-6.8, 35.8], zoom: 1.1 },
  'Sweden Cities': { center: [17.6435, 62.1282], zoom: 1.1 },
  'Switzerland Cities': { center: [8.2275, 46.8182], zoom: 1.1 },
  'Turkey Cities': { center: [35.2433, 38.9637], zoom: 1.1 },
  'Thailand Cities': { center: [101.5, 12.97], zoom: 1.1 },
  'Vietnam Cities': { center: [105.7772, 16.0583], zoom: 1.1 },
  'Indonesia Cities': { center: [117.9213, -2.5], zoom: 1.1 },
  'UK Cities': { center: [-6.1743, 55.2], zoom: 1.1 },
  'UAE Cities': { center: [54.2, 24.3], zoom: 1.1 },
  'Canada Cities': { center: [-97.3468, 62.2504], zoom: 1.1 },
  'USA Cities': { center: [-95.5, 37.5], zoom: 1.1 },
};
export const aspectScaleMap: Record<string, number> = {
  World: 1.0,
  'World Cities': 1.0,

  // India: 0.85,
  India : 0.92,
  'Indian Cities': 0.92,

  Australia: 0.92,
  'Australia Cities': 0.92,
  
  Austria: 0.7,
  'Austria Cities': 0.7,

  Argentina: 0.76,
  'Argentina Cities': 0.76,

  Brazil: 0.94,
  'Brazil Cities': 0.94,

  Belgium: 0.65,
  'Belgium Cities': 0.65,

  Canada: 0.45,
  'Canada Cities': 0.45,

  China: 0.8,
  'China Cities': 0.8,

  France: 0.7,
  'France Cities': 0.7,

  Germany: 0.65,
  'Germany Cities': 0.65,

  Indonesia: 0.95,
  'Indonesia Cities': 0.95,

  Ireland: 0.6,
  'Ireland Cities': 0.6,

  Israel: 0.85,
  'Israel Cities': 0.85,

  Italy: 0.8,
  'Italy Cities': 0.8,

  Japan: 0.8,
  'Japan Cities': 0.8,

  Malaysia: 0.8,
  'Malaysia Cities': 0.8,

  Mexico: 0.85,
  'Mexico Cities': 0.85,

  Norway: 0.44,
  'Norway Cities': 0.44,

  Nigeria: 0.95,
  'Nigeria Cities': 0.95,

  Poland: 0.62,
  'Poland Cities': 0.62,

  Russia: 0.43,
  'Russia Cities': 0.43,

  'Saudi Arabia': 0.9,
  'Saudi Arabia Cities': 0.9,

  Singapore: 1,
  'Singapore Cities': 1,

  'South Africa': 0.9,
  'South Africa Cities': 0.9,

  'South Korea': 0.82,
  'South Korea Cities': 0.82,

  Spain: 0.75,
  'Spain Cities': 0.75,

  Sweden: 0.45,
  'Sweden Cities': 0.45,

  Switzerland: 0.7,
  'Switzerland Cities': 0.7,

  Turkey: 0.81,
  'Turkey Cities': 0.81,

  Thailand: 0.95,
  'Thailand Cities': 0.95,

  UAE: 0.9,
  'UAE Cities': 0.9,

  UK: 0.6,
  'UK Cities': 0.6,

  USA: 0.8,
  'USA Cities': 0.8,

  Vietnam: 0.92,
  'Vietnam Cities': 0.92,
};